import { render } from "./LikeAction.vue?vue&type=template&id=063005d3"
import script from "./LikeAction.vue?vue&type=script&lang=js"
export * from "./LikeAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__